import dayjs from "dayjs";
import { PdfHeader, UiProfileModel, UiWarningRating } from "../../components";
import { userIcon } from "../../assets/images";

const ConsultationReport = ({ data, activeTab, allConsultationData, consultation, selectedMonth, selectedMonthString }) => {
    const lawyerConsultationIfo = allConsultationData?.result?.consultationCumulativeResponse;
    const lawyerInformation = allConsultationData?.result?.consultationCumulativeResponse?.lawyerResponse;
    const customerInformation = allConsultationData?.result?.consultationCumulativeResponse?.customerResponse;
    return <div className="consultation-Report">
        <div className="report-container">
            <PdfHeader fromDate={consultation?.fromDate} toDate={consultation?.toDate} pdfName={
                activeTab === "COMPLETED" ? "Completed Consultation Report" :
                activeTab === "CANCELLED" ? "Cancelled Consultation Report" :
                activeTab === "AUTO_CANCELLED" ? "Auto Cancelled Consultation Report" :
                "UpComing Consultation Report"
            } selectedMonth={selectedMonth} selectedMonthString={selectedMonthString} />
            <div style={{ padding: "10px" }}>
                <div style={{ backgroundColor: "#DFD5A98A", padding: "10px 0px 20px 0px", height: "90px", borderRadius: "8px" }}>
                    <div className="flexible">
                        <div className="flexible">
                            <div style={{ display: "flex", justifyContent: "space-around", padding: "10px 10px", gap: "10px" }}>
                                {
                                    !consultation?.profile || consultation?.profile?.includes("null") || consultation?.profile?.includes("undefined") ? <img src={userIcon} style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover" }} alt="" /> : <UiProfileModel imageUrl={consultation?.profile} />
                                }
                                <div>
                                    {
                                        lawyerInformation ? <h3 className="lawerInfo-detail">{lawyerInformation?.salutation || "Nil"} {lawyerInformation?.firstName || "Nil"} {lawyerInformation?.middleName || "Nil"} {lawyerInformation?.lastName || "Nil"}</h3> :
                                            <h3 className="lawerInfo-detail">{customerInformation?.salutation || "Nil"} {customerInformation?.firstName || "Nil"} {customerInformation?.middleName || "Nil"} {customerInformation?.lastName || "Nil"}</h3>
                                    }
                                    <div style={{ padding: "5px 10px" }}>
                                        <UiWarningRating count={lawyerInformation ? lawyerInformation?.warningCountAfterActive : customerInformation?.warningCountAfterActive} />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="flexible">
                                    <div style={{ borderRight: "1px solid gray", padding: "5px 10px" }}>
                                        <small className="information-header">Revenue</small>
                                        <h4 className="lawerInfo-detail">{lawyerConsultationIfo?.revenue || "Nil"}</h4>
                                    </div>
                                    <div style={{ borderRight: "1px solid gray", padding: "5px 10px" }}>
                                        <small className="information-header">Total Earnings</small>
                                        <h4 className="lawerInfo-detail">{lawyerConsultationIfo?.totalEarning || "Nil"}</h4>
                                    </div>
                                    <div style={{ padding: "5px 10px" }}>
                                        <small className="information-header">Total Penalty</small>
                                        <h4 className="lawerInfo-detail">{lawyerConsultationIfo?.penaltyAmount || "Nil"}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flexible">
                            <div>
                                <small className="information-header">Total <br />Cons.</small>
                                <h4 className="lawerInfo-detail">{lawyerConsultationIfo?.totalConsultation || "Nil"}</h4>
                            </div>
                            <div>
                                <small className="information-header">Cancelled <br />Cons.</small>
                                <h4 className="lawerInfo-detail">{lawyerConsultationIfo?.totalCancelConsultation || "Nil"}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <table className="report-table">
                <thead>
                    <tr>
                        <th colSpan={2}>SNo</th>
                        <th colSpan={3}>Cons. ID</th>
                        <th colSpan={3}>Customer ID</th>
                        <th colSpan={4}>Date</th>
                        <th colSpan={3}>Start-Time</th>
                        <th colSpan={3}>End Time</th>
                        <th colSpan={5}>Specialization</th>
                        <th colSpan={3}>Add on</th>
                        {
                            activeTab === "COMPLETED" ? <>
                                <th colSpan={3}>Expand Time</th>
                                <th colSpan={3}>Fees</th>
                                <th colSpan={5}>Record</th>
                                <th colSpan={5}>Complaint</th>
                                <th colSpan={5}>Feedback</th>
                            </> : activeTab === "CANCELLED" ? <>
                                <th colSpan={5}>Reason For Cancellation</th>
                            </> : <>
                            </>
                        }
                    </tr>
                </thead>
                <tbody>
                    {data?.map((detail, index) => {
                        const extendList = detail?.extendConsultionDetailsList || [];
                        const totalExtendMin = extendList?.reduce((sum, extenTime) => {
                            const val = Number(extenTime?.extendMin) || 0;
                            return sum + val;
                        }, 0);
                        const addOns = detail?.consultationPaymentDetails?.addOnList?.map(addonInfo => addonInfo?.addOn) || [];
                        return <tr key={index}>
                            <td colSpan={2}>{index + 1}</td>
                            <td colSpan={3}>{detail?.consultationNo || "Nil"}</td>
                            <td colSpan={3}>{detail?.customerResponse?.customerNo || "Nil"}</td>
                            <td colSpan={4}>{detail?.consultationDate ? dayjs(detail?.consultationDate)?.format("DD-MM-YYYY") : "Nil"}</td>
                            <td colSpan={3}>{detail?.consultationStartTime ? dayjs(detail?.consultationStartTime)?.format("hh:mm A") : "Nil"}</td>
                            <td colSpan={3}>{detail?.consultationEndTime ? dayjs(detail?.consultationEndTime)?.format("hh:mm A") : "Nil"}</td>
                            <td colSpan={5}>{detail?.specialization?.join(",") || "Nil"}</td>
                            <td colSpan={3}>{addOns?.join(", ") || "Nil"}</td>
                            {
                                activeTab === "COMPLETED" ? <>
                                    <td colSpan={3}>{totalExtendMin}</td>
                                    <td colSpan={3}>&#8377;{detail?.fees || "Nil"}</td>
                                    <td colSpan={5}>
                                        {
                                            detail?.record ? <div className="success-status"><p>Recorded</p></div> : <div className="danger-status"><p>Not Recorded</p></div>
                                        }
                                    </td>
                                    <td colSpan={5}>
                                        {
                                            detail?.consultationStatus && detail?.consultationStatus === "COMPLETED" ? <div className="success-status"><p>Completed</p></div> : detail?.consultationStatus && detail?.consultationStatus === "PENDING" ? <div className="pending-status"><p>Pending</p></div> : "Nil"
                                        }
                                    </td>
                                    <td colSpan={5}>{detail?.feedback?.feedback || "Nil"}</td>
                                    </> : (activeTab === "CANCELLED" || activeTab === "AUTO_CANCELLED") ? <>
                                        <td colSpan={5}>{detail?.cancelDetails?.reason || "Nil"}</td>
                                </> : <>
                                </>
                            }
                        </tr>
                    })}
                </tbody>
            </table>
        </div>
    </div>
};
export default ConsultationReport